import { resolveAbsoluteMediaUrl, resolveMediaUrl } from '~/utils/mediaUrl'

export interface FooterBadges {
  enabled: boolean
  paymentLogoUrl: string
  anpcSalImageUrl: string
  anpcSalLinkUrl: string
  anpcSolImageUrl: string
  anpcSolLinkUrl: string
}

export const DEFAULT_FOOTER_BADGES: FooterBadges = {
  enabled: true,
  paymentLogoUrl: '/images/footer/netopia-white.svg',
  anpcSalImageUrl: '/images/footer/anpc-sal.webp',
  anpcSalLinkUrl: 'https://anpc.ro/ce-este-sal/',
  anpcSolImageUrl: '/images/footer/anpc-sol.webp',
  anpcSolLinkUrl: 'https://anpc.ro/ce-este-sol/',
}

export function parseFooterBadges(raw?: string | null): FooterBadges {
  if (!raw) return { ...DEFAULT_FOOTER_BADGES }
  try {
    const parsed = JSON.parse(raw) as Partial<FooterBadges>
    return {
      ...DEFAULT_FOOTER_BADGES,
      ...parsed,
      enabled: parsed.enabled !== false,
    }
  } catch {
    return { ...DEFAULT_FOOTER_BADGES }
  }
}

export function resolveAssetUrl(url: string, apiOrigin?: string): string {
  if (!url) return ''
  if (url.startsWith('http') || url.startsWith('data:')) return url
  return resolveMediaUrl(url, apiOrigin)
}
